import React from 'react';
import { PageHero } from '../components/layout/PageHero';
import { RelatedInitiative } from '../components/initiatives/RelatedInitiative';
import { ProjectFeature } from '../components/projects/ProjectFeature';
import { ProjectMaterials } from '../components/projects/ProjectMaterials';
import { initiatives } from '../data/initiatives';
export function ProjectsPage() {
  return <>
      <PageHero eyebrow="Projects" title="Larger ideas. Connected systems." lead="Explore initiatives that bring SyNeural’s technology and research into broader civic and institutional settings." body={['More projects will be added here as they are ready to present.']} data-id="element-3378" data-mp="itenn7puxp9i" />
      {initiatives.map(project => <ProjectFeature key={project.slug} project={project} data-id="element-3379" data-mp="dulj44sjt8lh" />)}
      <ProjectMaterials data-id="element-3380" data-mp="23a1iisgo7fy6" />
      <RelatedInitiative label="Supporting Research" name="Research" body="The methods, questions and studies behind SyNeural’s projects." href="/research" linkLabel="Explore Research" data-id="element-3381" data-mp="239jcx584bpdl" />
    </>;
}